import Default from "../Pages/Dashboard/Default/Default";
import CardAssign from "../Pages/Cardasign/CardAssign";
import AllCardAssign from "../Pages/Application/Master/book_ticket/AllCardAssign";
import AccountSettings from "../Pages/SamplePage/AccountSettings";
import AccountProfile from "../Pages/SamplePage/AccountProfile";


const cardAssignCRoutes = [
  // dashboard
  { path: `${process.env.PUBLIC_URL}/dashboard/default`, Component: <Default /> },

  // Account
   { path: `${process.env.PUBLIC_URL}/account/account_settings`, Component: <AccountSettings /> },
   { path: `${process.env.PUBLIC_URL}/account/account_profile`, Component: <AccountProfile /> },
  //  { path: `${process.env.PUBLIC_URL}/card/card_assign`, Component: <CardAssign/> },
  // { path: `${process.env.PUBLIC_URL}/card/all_card_assign`, Component: <AllCardAssign/> },
];

export default cardAssignCRoutes;
